/**
 * MenuRequestListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Text,
  Statistic,
  ModalLayout,
  Descriptions,
  LoadingPage,
} from 'components';
import { Avatar, Button, DatePicker, Input, Radio, Select, Tag } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { stringToMoneyFormat, getDateRange } from 'utils';
import { encrypt } from 'utils/Crypto';
import moment from 'moment';
import Formatter from 'utils/Formatter';

const MenuRequestListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    data,
    categoryData,
    modalType,
    isOpened,
    onOpen,
    onSubmit,
    onSearch,
    searchInputValue,
    parameter,
    navigate,
    onSearchChange,
  } = props;
  /* ===== STATE ===== */
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleRowClick = (item) => {
    // console.log(item);
    setSelectedItem(item);
    onOpen(isOpened, 'menu_info');
  };
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '메뉴명', value: 'menuName' },
                  { label: '매장명', value: 'storeName' },
                ]}
                style={{ ...styles.form.input.large }}
                value={searchInputValue?.searchKey}
                onChange={(e) => onSearchChange('searchKey', e)}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
                value={searchInputValue?.searchValue}
                onChange={(e) => onSearchChange('searchValue', e.target.value)}
              />
              {/* <Button size="large" icon={<PlusOutlined />} /> */}
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 카테고리',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={
                  categoryData?.map((category) => ({
                    label: category.product_category_name,
                    value: encrypt(category.product_category_id),
                  })) || []
                }
                style={{ ...styles.form.input.large }}
                placeholder={'카테고리 선택'}
                value={searchInputValue?.category ?? null}
                onChange={(e) => onSearchChange('category', e)}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 신청일',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(0);

                onSearchChange(
                  'applicationStartDate',
                  moment(start).format('YYYY-MM-DD')
                );
                onSearchChange(
                  'applicationEndDate',
                  moment(end).format('YYYY-MM-DD')
                );
              }}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(7);

                onSearchChange(
                  'applicationStartDate',
                  moment(start).format('YYYY-MM-DD')
                );
                onSearchChange(
                  'applicationEndDate',
                  moment(end).format('YYYY-MM-DD')
                );
              }}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(30);

                onSearchChange(
                  'applicationStartDate',
                  moment(start).format('YYYY-MM-DD')
                );
                onSearchChange(
                  'applicationEndDate',
                  moment(end).format('YYYY-MM-DD')
                );
              }}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(90);

                onSearchChange(
                  'applicationStartDate',
                  moment(start).format('YYYY-MM-DD')
                );
                onSearchChange(
                  'applicationEndDate',
                  moment(end).format('YYYY-MM-DD')
                );
              }}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                onSearchChange('applicationStartDate', '');
                onSearchChange('applicationEndDate', '');
              }}
            >
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.applicationStartDate
                  ? {
                      value: searchInputValue?.applicationStartDate
                        ? moment(searchInputValue?.applicationStartDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onSearchChange('applicationStartDate', dateString)
                }
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.applicationEndDate
                  ? {
                      value: searchInputValue?.applicationEndDate
                        ? moment(searchInputValue?.applicationEndDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  onSearchChange('applicationEndDate', dateString)
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '승인 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={searchInputValue?.applicationStatus ?? null}>
                <Radio
                  value={null}
                  onChange={(e) =>
                    onSearchChange('applicationStatus', e.target.value)
                  }
                >
                  전체
                </Radio>
                <Radio
                  value={'APPLY'}
                  onChange={(e) =>
                    onSearchChange('applicationStatus', e.target.value)
                  }
                >
                  신청
                </Radio>
                <Radio
                  value={'APPROVE'}
                  onChange={(e) =>
                    onSearchChange('applicationStatus', e.target.value)
                  }
                >
                  승인
                </Radio>
                <Radio
                  value={'REJECT'}
                  onChange={(e) =>
                    onSearchChange('applicationStatus', e.target.value)
                  }
                >
                  반려
                </Radio>
                <Radio
                  value={'WAIT'}
                  onChange={(e) =>
                    onSearchChange('applicationStatus', e.target.value)
                  }
                >
                  대기
                </Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 오늘 날짜 unix 타입 반환
   * --
   * @returns {array}
   */
  const getTodayUnixTimes = () => {
    const now = new Date();

    // 오늘 00:00:00
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDayUnix = Math.floor(startOfDay.getTime() / 1000);

    // 오늘 23:59:59
    const endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );
    const endOfDayUnix = Math.floor(endOfDay.getTime() / 1000);

    return [startOfDayUnix, endOfDayUnix];
  };
  /* ===== HOOKS ===== */
  /**
   * 테이블 데이터 정제
   * --
   */
  const newData = React.useMemo(() => {
    setIsLoading(true);

    const newCategory = data?.map((item, index) => ({
      no: index + 1,
      카테고리: item.category_name,
      메뉴코드: item.menu_id,
      img: <Avatar size={32} shape="square" icon={<PictureOutlined />} />,
      name: (
        <p style={{ display: 'flex', alignItems: 'center' }}>
          <Tag
            // color={i === 0 ? '#37383C' : i === 1 ? '#58CF04' : '#EAA300'}
            style={{
              background: 'none',
              color:
                item.application_status === 'APPLY'
                  ? '#37383C'
                  : item.application_status === 'APPROVE'
                  ? '#58CF04'
                  : '#EAA300',
              borderColor:
                item.application_status === 'APPLY'
                  ? '#37383C'
                  : item.application_status === 'APPROVE'
                  ? '#58CF04'
                  : '#EAA300',
              width: 48,
              fontSize: 8,
              fontWeight: 600,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {item.application_status === 'APPLY'
              ? '승인신청'
              : item.application_status === 'APPROVE'
              ? '승인'
              : item.application_status === 'REJECT'
              ? '반려'
              : '대기'}
          </Tag>
          {item.menu_name}
        </p>
      ),
      price: item.price,
      menu_content: item.menu_content,
      수량: item.num,
      판매처: (
        <button
          style={{
            border: 'none',
            background: 'none',
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          {item.shop_name}
        </button>
      ),
      승인상태: (
        <Select
          value={item.application_status}
          options={[
            { label: '승인신청', value: 'APPLY' },
            { label: '승인', value: 'APPROVE' },
            { label: '반려', value: 'REJECT' },
          ]}
          style={{ ...styles.form.input.medium }}
          onChange={(value) => onSubmit('MENU', 'UPDATE', item.menu_id, value)}
        />
      ),
      menu_data: { ...item },

      storeName: item?.shop_name,
      menuName: item?.menu_name,
      application: item?.created_at,
      applicationStatus: item?.application_status,
      category: encrypt(item?.product_category_id),
    }));

    const { searchKey, searchValue, ...remainParameter } = parameter;

    const filterCategories = newCategory?.filter((user) =>
      Object.entries(remainParameter).every(([key, value]) => {
        if (!value) return true;

        // 키값이 시작값인 경우
        if (key.includes('Start')) {
          const newKey = key.split('Start');

          if (key.includes('Date')) {
            const unix = Formatter.dateToUnix(`${value} 00:00:00`);

            return user[newKey[0]] >= unix;
          }

          return user[newKey[0]] >= value;
        }

        // 키값이 종료값인 경우
        if (key.includes('End')) {
          const newKey = key.split('End');

          if (key.includes('Date')) {
            const unix = Formatter.dateToUnix(`${value} 23:59:59`);

            return user[newKey[0]] <= unix;
          }

          return user[newKey[0]] <= value;
        }

        return user[key] === value;
      })
    );

    const searchCategories =
      searchKey && searchValue
        ? filterCategories?.filter((user) =>
            user[searchKey]?.includes(searchValue)
          )
        : filterCategories;

    // 페이징 처리
    // const pagingUser = searchCategories?.slice((page - 1) * count, page * count);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return { data: searchCategories, total: searchCategories?.length };
    // eslint-disable-next-line
  }, [parameter, data]);

  /**
   * 메뉴 신청 요약 데이터 정제
   * --
   */
  const summaryMenuData = React.useMemo(() => {
    // NOTE: 오늘 날짜 시작일 종료일 [YYYY-MM-DD 00:00:00 ~ YYYY-MM-DD 23:59:59]
    const [startTime, endTime] = getTodayUnixTimes();

    let summary = {
      TOTAL: {
        title: '전체 신청',
        value: 0,
      },
      APPROVE: {
        title: '전체 승인',
        value: 0,
      },
      APPLY: {
        title: '전체 신청',
        value: 0,
      },
      REJECT: {
        title: '전체 반려',
        value: 0,
      },
      WAIT: {
        title: '전체 대기',
        value: 0,
      },
      TODAY: {
        title: '오늘 신청',
        value: 0,
      },
    };
    data?.forEach(({ application_status, created_at }) => {
      const isToday = created_at > startTime && created_at < endTime;

      // 오늘 신청건
      if (isToday) {
        ++summary['TODAY']['value'];
      }

      ++summary[application_status]['value'];
      // 전체 회원
      ++summary['TOTAL']['value'];
    });

    return Object.entries(summary).map(([key, value]) => ({
      key,
      ...value,
    }));
  }, [data]);

  /* ===== RENDER ===== */
  return (
    <>
      {isLoading ? <LoadingPage text={'검색중..'} /> : null}
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>메뉴 목록</Title>

            {/* 요약 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40, display: 'flex' }}
            >
              {summaryMenuData?.map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `calc(100% / 6)`,
                    marginRight: _index === 5 ? 0 : 4,
                    padding: 20,
                  }}
                >
                  <Statistic
                    title={_item.title}
                    value={_item.value}
                    suffix={'건'}
                    direction={'row'}
                    style={{ justifyContent: 'center' }}
                  />
                </div>
              ))}
            </Content>
            {/* 요약 끝 */}

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 48,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                  onClick={() => onSearch()}
                >
                  검색
                </Button>
                <Button
                  size="large"
                  style={{ ...styles.button }}
                  onClick={() => navigate('/menu/request-list')}
                >
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              style={{ minHeight: 530 }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <h4
                    style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                  >
                    총 <span>{newData?.total}</span>건
                  </h4>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    복사
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    삭제
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    분류수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    메인진열수정
                  </Button>
                </div>
                {/* <div>
                  <Select
                    size="large"
                    value={'신청일순'}
                    options={[
                      { label: '신청일순', value: '신청일순' },
                      { label: '신청일순2', value: '신청일순2' },
                    ]}
                  />
                </div> */}
              </div>
              <Table
                data={newData?.data}
                isChecked
                onRow={(item) => handleRowClick(item)}
                columns={[
                  {
                    title: 'No',
                    key: 'no',
                    width: 10,
                  },
                  {
                    title: '카테고리',
                    key: '카테고리',
                  },
                  {
                    title: '메뉴코드',
                    key: '메뉴코드',
                  },
                  {
                    title: '이미지',
                    key: 'img',
                  },
                  {
                    title: '메뉴명',
                    key: 'name',
                    width: 300,
                  },
                  {
                    title: '판매가',
                    key: 'price',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '메뉴내용',
                    key: 'menu_content',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '수량',
                    key: '수량',
                    render: (item) => stringToMoneyFormat(item),
                  },
                  {
                    title: '판매처',
                    key: '판매처',
                  },
                  {
                    title: '승인상태',
                    key: '승인상태',
                  },
                ]}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={isOpened && modalType === 'menu_info'}
        onCancel={() => onOpen(isOpened)}
        centered
        closable
        title={'메뉴정보'}
        width={884}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Button onClick={() => onOpen(isOpened)}>닫기</Button>
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={10}>
                <Descriptions
                  align="left"
                  column={4}
                  items={[
                    {
                      key: `1`,
                      label: '메뉴명',
                      children: selectedItem?.menu_data?.menu_name
                        ? selectedItem?.menu_data?.menu_name
                        : '-',
                      span: 2,
                    },
                    {
                      key: `2`,
                      label: '메뉴번호',
                      children: selectedItem?.menu_data?.menu_id
                        ? '0000' + selectedItem?.menu_data?.menu_id
                        : '-',
                      span: 2,
                    },
                    {
                      key: `3`,
                      label: '단가',
                      children: selectedItem?.menu_data?.price
                        ? stringToMoneyFormat(
                            selectedItem?.menu_data?.price,
                            '원'
                          )
                        : '-',
                      span: 4,
                    },
                    {
                      key: `4`,
                      label: '설명',
                      children: selectedItem?.menu_data?.menu_content
                        ? selectedItem?.menu_data?.menu_content
                        : '-',
                      span: 4,
                    },
                    {
                      key: 5,
                      label: '기타옵션',
                      children: !selectedItem?.menu_data?.menu_option
                        ? '-'
                        : selectedItem?.menu_data?.menu_option?.map(
                            (option, _index, _arr) => (
                              <div
                                key={`option_${_index}`}
                                style={{
                                  padding: '10px 20px',
                                  borderBottom:
                                    _arr.length === _index + 1
                                      ? 'none'
                                      : '1px solid rgba(112, 115, 124, 0.2)',
                                }}
                              >
                                <Text size={13} weight={600} color={'#454545'}>
                                  {option.option_title || 'Option'}
                                </Text>
                                <Radio.Group
                                  style={{ marginTop: 8 }}
                                  value={''}
                                >
                                  {option.option?.map((_item) => (
                                    <Radio
                                      key={`item_${_item.option_key}`}
                                      value={_item}
                                    >
                                      {_item.option_name || 'Option Name'}
                                    </Radio>
                                  ))}
                                </Radio.Group>
                              </div>
                            )
                          ),
                      span: 4,
                      style: { padding: 0 },
                    },
                    {
                      key: `6`,
                      label: '이미지',
                      children: (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            padding: '20px 0px',
                          }}
                        >
                          {selectedItem?.menu_data?.files?.map((_, _index) => (
                            <Avatar
                              key={`img_${_index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={_}
                            />
                          ))}
                        </div>
                      ),
                      span: 4,
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default MenuRequestListPresenter;
